<!--child.vue-->
<template>
  <div class="tips_wrap">
    <el-dialog :close-on-click-modal="false" title="房间类别管理" :visible.sync="dialogFormVisible" @close="closeDialog">

      <div style=" display: flex;">
        <div>
          <el-input clearable style="width:200px;margin-right: 10px;" placeholder="请输入类别名称" v-model="homeTypeName" />
        </div>
        <el-button style="margin-right: 10px;" @click="clear">清空</el-button>

        <el-button style="margin-right: 10px;" @click="add">新增</el-button>

      </div>
      <el-table :data="gridData" style="width: 100%" height="400px">
        <el-table-column label="序号" type="index" width="50">
        </el-table-column>
        <el-table-column property="homeTypeName" label="名称" width="350"></el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="update(scope.row)" size="small">修改</el-button>

            <el-button type="text" @click="delfirm(scope.row)" size="small">删除</el-button>

          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {

  props: {
    dialogShow: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    console.log("我是子组件");
  },

  data() {
    return {
      homeTypeName: "",
      req: {
        pageIndex:0,
        pageCount:100,
        query:{
        sysUserId:"1",
        id: "",
        homeTypeName: "",
        }
      },
      dialogFormVisible: this.dialogShow,
      gridData: [],
    }
  },
  created() {
    this.req.query.sysUserId=this.$store.state.user.user.id
    this.pushData()
  },
  watch: {
    dialogShow(val) {
      this.dialogFormVisible = val
    },
    homeTypeName(val) {
      var that = this;
      this.req.query.homeTypeName=this.homeTypeName
      this.$axios.post("/api2/business/getHomeType", this.req)
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.gridData = response.data.data
          } else {
            that.$message.error(response.data.mes);
          }
        })
    },


  },
  methods: {
    add(){
      var that = this;
      that.req.query.id=""
      that.req.query.homeTypeName=this.homeTypeName
      this.$axios.post("/api2/business/UpdateOrAddHomeType", that.req.query)
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.$message({
              type: 'success',
              message: "操作成功"
            });
            that.homeTypeName=""
            that.pushData()
          } else {
            that.$message.error(response.data.mes);
          }
        })
    },
    delfirm(row){
      this.$confirm('此操作删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.del(row)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      
    },
    clear(){
      this.homeTypeName=""
    },
    pushData() {
      var that = this;
      this.req.query.homeTypeName=""
      this.$axios.post("/api2/business/getHomeType",  this.req)
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.gridData = response.data.data
          } else {
            that.$message.error(response.data.mes);
          }
        })
    },
    update(row) {
      this.req.query.id = row.id
      var that = this
      this.$prompt('请输入新名称', '修改', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.homeTypeName
      }).then(({ value }) => {
        that.req.query.homeTypeName = value
        that.updateType()

      })
    },
    del(row) {
      var that = this;
  
      this.$axios.get("/api2/business/delHomeType/"+row.id, {})
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.$message({
              type: 'success',
              message: "操作成功"
            });
            that.pushData()
          } else {
            that.$message.error(response.data.mes);
          }
        })
    
    },
    closeDialog() {
      this.$emit('brandShowChange', false)
    },
    updateType() {
      var that = this;
      this.$axios.post("/api2/business/UpdateOrAddHomeType", that.req.query)
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.$message({
              type: 'success',
              message: "操作成功"
            });
            that.pushData()
          } else {
            that.$message.error(response.data.mes);
          }
        })
    }

  }
}
</script>

